import * as React from 'react';
import { ModalCreateContainer } from '../../containers/ModalCreateContainer';
import { ECreateFolderSource } from '../../types';
import { ModalConfirm } from '../ModalConfirm';
import { CreateFolderContainer } from '../../containers/CreateFolderContainer';
import { Header3, InlineText1 } from '@cian/ui-kit';
import { OnBoardingDelete } from '../OnBoardingDelete';
import { ListContainer } from '../../containers/ListContainer';
import * as styles from './FavoritesAssignWidget.css';
export function FavoritesAssignWidget(_ref) {
  var _ref$selectedIds = _ref.selectedIds,
      selectedIds = _ref$selectedIds === void 0 ? {} : _ref$selectedIds,
      _ref$isShowFoldersLis = _ref.isShowFoldersList,
      isShowFoldersList = _ref$isShowFoldersLis === void 0 ? false : _ref$isShowFoldersLis,
      isShowOnBoardingDelete = _ref.isShowOnBoardingDelete,
      isListLoading = _ref.isListLoading,
      isCreating = _ref.isCreating,
      hideCloseButton = _ref.hideCloseButton,
      children = _ref.children,
      _ref$onCreateFolder = _ref.onCreateFolder,
      onCreateFolder = _ref$onCreateFolder === void 0 ? function () {} : _ref$onCreateFolder,
      _ref$onSaveSelectedFo = _ref.onSaveSelectedFolders,
      onSaveSelectedFolders = _ref$onSaveSelectedFo === void 0 ? function () {} : _ref$onSaveSelectedFo,
      _ref$onHide = _ref.onHide,
      onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
      _ref$onCloseFoldersLi = _ref.onCloseFoldersList,
      onCloseFoldersList = _ref$onCloseFoldersLi === void 0 ? function () {} : _ref$onCloseFoldersLi,
      _ref$onOpenFoldersLis = _ref.onOpenFoldersList,
      onOpenFoldersList = _ref$onOpenFoldersLis === void 0 ? function () {} : _ref$onOpenFoldersLis;

  var handleCreate = function handleCreate(name) {
    onCreateFolder(name, ECreateFolderSource.Notification);
  };

  var handleOpenChangeModal = function handleOpenChangeModal() {
    onOpenFoldersList();
  };

  var handleConfirm = function handleConfirm() {
    onSaveSelectedFolders();
  };

  var handleCloseChangeModal = function handleCloseChangeModal() {
    onHide();
    onCloseFoldersList();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OnBoardingDelete, {
    visible: isShowOnBoardingDelete
  }), children, /*#__PURE__*/React.createElement(ModalCreateContainer, {
    onConfirm: handleCreate
  }), isShowFoldersList && /*#__PURE__*/React.createElement(ModalConfirm, {
    fullScreen: hideCloseButton,
    fixed: true,
    header: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles['title']
    }, /*#__PURE__*/React.createElement(Header3, null, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0432\xA0\u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443")), /*#__PURE__*/React.createElement("div", {
      className: styles['subtitle']
    }, /*#__PURE__*/React.createElement(InlineText1, {
      color: "gray60_100"
    }, "\u041E\u0431\u044A\u0435\u043A\u0442 \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D \u0432\xA0\u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0438\xA0\u0432\xA0\u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0438")), /*#__PURE__*/React.createElement(CreateFolderContainer, {
      onCreate: function onCreate(name) {
        return onCreateFolder(name, ECreateFolderSource.List);
      },
      isCreating: isCreating
    })),
    isVisible: true,
    isLoading: isListLoading,
    confirmButtonDisabled: !Boolean(Object.keys(selectedIds).length),
    onConfirm: handleConfirm,
    onCancel: handleCloseChangeModal,
    onOpen: handleOpenChangeModal
  }, /*#__PURE__*/React.createElement(ListContainer, null)));
}